// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PackerIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="#02A8EF"
      fillRule="evenodd"
      d="m5 3.69 7.13 4.12V23L5 18.88z"
      clipRule="evenodd"
    />
    <path
      fill="#02A8EF"
      d="M15.66 5.46 7.91 1v3.1l5.27 3.05v9.3l2.48 1.42c1.53.9 2.79.36 2.79-1.18V9.87c0-1.54-1.25-3.52-2.79-4.4"
    />
  </svg>,
  "Packer",
);
export default PackerIcon;
